// import Sidebar from "../components/Sidebar"
import RegisterBox from "../components/register/RegisterBox"
import '../components/register/RegisterBox.css'
import HeroMessage from "../components/register/HeroMessage"
import TopNavbar from "../components/top-navbar/TopNavbar"
import RegisterContext from "../components/contexts/RegisterContext"
import { useContext, useState, useEffect } from 'react'

function Register() {
   // variable to track user status
   const {user, noMatch} = useContext(RegisterContext);

   useEffect(() => {
    document.title = "Register";  
    document.documentElement.lang = "en";
}, []);

   return(
    <div id="rg-body">
       <div>
            <TopNavbar />
            <div className = "rg-main-screen">
                <div className="rg-container">
                    <HeroMessage/> 
                    <div className = "Register">
                        <RegisterBox />
                    </div>
                </div>
            </div>
       </div>
    </div>
   )
}
export default Register